import { Mappable } from "../../../_shared/mappable.class";
import { FundraisingSite } from "../FundraisingSite";
import { PledgePerWin } from "./PledgePerWin";

export class PledgePerWinSite extends FundraisingSite {

    pledgePerWinSiteId: number;
    supportAddresses: string[];
}